import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
import { z } from 'zod';
// plaid access token request schema
export const plaidAccessTokenRequestSchema = z.object({
    publicToken: z.string(),
});
/**
 * Hook for exchanging a Plaid public token for an access token
 */
export const useCreateAccessTokenApi = (mutationConfig) => {
    const api = useApi();
    const queryClient = useQueryClient();
    const { onSuccess, onError, ...restConfig } = mutationConfig || {};
    const plaidAccessTokenApi = async (data) => {
        await api.post('/plaid/access-token', data);
    };
    return useMutation({
        onSuccess: (...args) => {
            queryClient.invalidateQueries({ queryKey: ['plaid-items'] }).then(() => { });
            queryClient.invalidateQueries({ queryKey: ['external-accounts'] }).then(() => { });
            onSuccess?.(...args);
        },
        onError,
        ...restConfig,
        mutationFn: plaidAccessTokenApi,
    });
};
